import { useEffect } from 'react'

/** Moves a soft highlight across whichever glass panel is under the cursor. */
export function useGlassLight() {
  useEffect(() => {
    const move = (e: PointerEvent) => {
      if (e.pointerType !== 'mouse') return
      const t = e.target
      if (!(t instanceof Element)) return
      const g = t.closest<HTMLElement>('.glass')
      if (!g) return
      const r = g.getBoundingClientRect()
      g.style.setProperty('--mx', `${e.clientX - r.left}px`)
      g.style.setProperty('--my', `${e.clientY - r.top}px`)
    }
    document.addEventListener('pointermove', move, { passive: true })
    return () => document.removeEventListener('pointermove', move)
  }, [])
}
